import RSelect from "react-select";
import PropTypes from "prop-types";
import useMenuPortalTargetRef from "hooks/useMenuPortalTargetRef";
import useEvent from "hooks/useEvent";
import STYLES from "./styles";
import COMPONENTS from "./components";

const closeMenuOnScroll = () => true;

export default function PerPageSelect({ value, options, onChange }) {
  const { current: menuPortalTarget } = useMenuPortalTargetRef();

  const handleChangePerPage = useEvent((option) => {
    onChange(option.value);
  });

  return (
    <RSelect
      value={value}
      options={options}
      styles={STYLES}
      components={COMPONENTS}
      onChange={handleChangePerPage}
      menuPortalTarget={menuPortalTarget}
      menuPosition="fixed"
      menuPlacement="auto"
      closeMenuOnScroll={closeMenuOnScroll}
      isSearchable={false}
    />
  );
}

PerPageSelect.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};
